export default __webpack_public_path__ + "static/Banners_a2-adb7ca7ca2afc1dbcdb900140ea43ec3.jpg";